// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

export var breakpoint = {
  xsMax: 575,
  smMin: 576,
  smMax: 767,
  mdMin: 768,
  mdMax: 991,
  lgMin: 992,
  lgMax: 1199,
  xlMin: 1200
};
export var color = {
  light: {
    foreground: {
      "default": '#212121',
      medium: '#404040',
      light: '#666666',
      disabled: '#a3a3a3'
    },
    background: {
      "default": '#fafafa',
      container: '#ffffff',
      disabled: '#e8e8e8'
    },
    stroke: {
      "default": '#d9d9d9'
    },
    effects: {
      glasswall: 'rgba(33,33,33,0.5)',
      dropShadow: 'rgba(33,33,33,0.2)'
    },
    spotlight: {
      foreground: {
        "default": '#212121',
        hover: '#212121',
        active: '#212121'
      },
      base: {
        "default": '#ffffff',
        hover: 'rgba(255,255,255,0.8)',
        active: 'rgba(255,255,255,0.6)'
      },
      background: {
        "default": '#212121',
        hover: 'rgba(255,255,255,0.1)',
        active: 'rgba(255,255,255,0.2)'
      }
    },
    primary: {
      foreground: {
        "default": '#ffffff',
        hover: '#ffffff',
        active: '#ffffff'
      },
      base: {
        "default": '#0073a8',
        hover: '#015985',
        active: '#02476b'
      },
      background: {
        "default": '#e6f0f5',
        hover: '#ceeffe',
        active: '#b7e8fe'
      }
    },
    neutral: {
      foreground: {
        "default": '#ffffff',
        hover: '#ffffff',
        active: '#ffffff'
      },
      base: {
        "default": '#666666',
        hover: '#545454',
        active: '#404040'
      },
      background: {
        "default": '#f1f1f1',
        hover: 'rgba(33,33,33,0.1)',
        active: 'rgba(33,33,33,0.2)'
      }
    },
    positive: {
      foreground: {
        "default": '#ffffff',
        hover: '#ffffff',
        active: '#ffffff'
      },
      base: {
        "default": '#00834b',
        hover: '#006c3e',
        active: '#005a35'
      },
      background: {
        "default": '#d5f5e7',
        hover: '#ccffe8',
        active: '#a3ffd6'
      }
    },
    warning: {
      foreground: {
        "default": '#212121',
        hover: '#212121',
        active: '#212121'
      },
      base: {
        "default": '#ff8900',
        hover: '#e07200',
        active: '#b2600c'
      },
      background: {
        "default": '#fcebdc',
        hover: '#ffdbb2',
        active: '#ffc98c'
      }
    },
    negative: {
      foreground: {
        "default": '#ffffff',
        hover: '#ffffff',
        active: '#ffffff'
      },
      base: {
        "default": '#cc2c00',
        hover: '#9f2301',
        active: '#802208'
      },
      background: {
        "default": '#faeceb',
        hover: '#ffdbd9',
        active: '#ffc1bd'
      }
    },
    caution: {
      foreground: {
        "default": '#5c4e00',
        hover: '#212121',
        active: '#212121'
      },
      base: {
        "default": '#ffe137',
        hover: '#f9d300',
        active: '#e5c300'
      },
      background: {
        "default": '#f7f2cb',
        hover: '#fff29e',
        active: '#ffe970'
      }
    },
    help: {
      foreground: {
        "default": '#ffffff',
        hover: '#ffffff',
        active: '#ffffff'
      },
      base: {
        "default": '#187585',
        hover: '#176673',
        active: '#16555f'
      },
      background: {
        "default": '#d7f4f7',
        hover: '#d4fbff',
        active: '#bcf7ff'
      }
    }
  },
  dark: {
    foreground: {
      "default": '#ffffff',
      medium: '#d9d9d9',
      light: '#a3a3a3',
      disabled: '#666666'
    },
    background: {
      "default": '#212121',
      container: '#292929',
      disabled: '#404040'
    },
    stroke: {
      "default": '#545454'
    },
    effects: {
      glasswall: 'rgba(33,33,33,0.7)',
      dropShadow: 'rgba(0,0,0,0.4)'
    },
    spotlight: {
      foreground: {
        "default": '#ffffff',
        hover: '#ffffff',
        active: '#ffffff'
      },
      base: {
        "default": '#212121',
        hover: 'rgba(33,33,33,0.8)',
        active: 'rgba(33,33,33,0.6)'
      },
      background: {
        "default": '#ffffff',
        hover: 'rgba(33,33,33,0.1)',
        active: 'rgba(33,33,33,0.2)'
      }
    },
    primary: {
      foreground: {
        "default": '#212121',
        hover: '#212121',
        active: '#212121'
      },
      base: {
        "default": '#3bb7f6',
        hover: '#73cffe',
        active: '#9fe0fe'
      },
      background: {
        "default": '#112d3b',
        hover: '#0e3245',
        active: '#0a3b54'
      }
    },
    neutral: {
      foreground: {
        "default": '#212121',
        hover: '#212121',
        active: '#212121'
      },
      base: {
        "default": '#a3a3a3',
        hover: '#c2c2c2',
        active: '#d9d9d9'
      },
      background: {
        "default": '#333333',
        hover: 'rgba(255,255,255,0.1)',
        active: 'rgba(255,255,255,0.2)'
      }
    },
    positive: {
      foreground: {
        "default": '#212121',
        hover: '#212121',
        active: '#212121'
      },
      base: {
        "default": '#00d072',
        hover: '#4ef5ab',
        active: '#78ffc2'
      },
      background: {
        "default": '#093021',
        hover: '#07412a',
        active: '#034c2e'
      }
    },
    warning: {
      foreground: {
        "default": '#212121',
        hover: '#212121',
        active: '#212121'
      },
      base: {
        "default": '#ff8900',
        hover: '#ffa238',
        active: '#ffb866'
      },
      background: {
        "default": '#382514',
        hover: '#4a3016',
        active: '#5c3a19'
      }
    },
    negative: {
      foreground: {
        "default": '#212121',
        hover: '#212121',
        active: '#212121'
      },
      base: {
        "default": '#ff6445',
        hover: '#ff8373',
        active: '#ffa59e'
      },
      background: {
        "default": '#422016',
        hover: '#522112',
        active: '#68240f'
      }
    },
    caution: {
      foreground: {
        "default": '#212121',
        hover: '#212121',
        active: '#212121'
      },
      base: {
        "default": '#ffe137',
        hover: '#ffe970',
        active: '#fff29e'
      },
      background: {
        "default": '#302900',
        hover: '#413700',
        active: '#544700'
      }
    },
    help: {
      foreground: {
        "default": '#212121',
        hover: '#212121',
        active: '#212121'
      },
      base: {
        "default": '#2ac5e0',
        hover: '#40defa',
        active: '#8aefff'
      },
      background: {
        "default": '#142c30',
        hover: '#173e45',
        active: '#15474f'
      }
    }
  },
  highContrast: {
    foreground: {
      "default": '#ffffff',
      medium: '#ffffff',
      light: '#ffffff',
      disabled: '#adadad'
    },
    background: {
      "default": '#16141d',
      container: '#16141d',
      disabled: '#545454'
    },
    stroke: {
      "default": '#adadad'
    },
    effects: {
      glasswall: '#16141d',
      dropShadow: 'rgba(22,20,29,0)'
    },
    spotlight: {
      foreground: {
        "default": '#16141d',
        hover: '#16141d',
        active: '#16141d'
      },
      base: {
        "default": '#fff700',
        hover: '#fe6aff',
        active: '#00d3ff'
      },
      background: {
        "default": '#ffffff',
        hover: '#fe6aff',
        active: '#00d3ff'
      }
    },
    primary: {
      foreground: {
        "default": '#16141d',
        hover: '#16141d',
        active: '#16141d'
      },
      base: {
        "default": '#fff700',
        hover: '#fe6aff',
        active: '#00d3ff'
      },
      background: {
        "default": '#16141d',
        hover: '#fe6aff',
        active: '#00d3ff'
      }
    },
    neutral: {
      foreground: {
        "default": '#16141d',
        hover: '#16141d',
        active: '#16141d'
      },
      base: {
        "default": '#fff700',
        hover: '#fe6aff',
        active: '#00d3ff'
      },
      background: {
        "default": '#16141d',
        hover: '#fe6aff',
        active: '#00d3ff'
      }
    },
    positive: {
      foreground: {
        "default": '#16141d',
        hover: '#16141d',
        active: '#16141d'
      },
      base: {
        "default": '#00d072',
        hover: '#fe6aff',
        active: '#00d3ff'
      },
      background: {
        "default": '#16141d',
        hover: '#fe6aff',
        active: '#00d3ff'
      }
    },
    warning: {
      foreground: {
        "default": '#16141d',
        hover: '#16141d',
        active: '#16141d'
      },
      base: {
        "default": '#ff8900',
        hover: '#fe6aff',
        active: '#00d3ff'
      },
      background: {
        "default": '#16141d',
        hover: '#fe6aff',
        active: '#00d3ff'
      }
    },
    negative: {
      foreground: {
        "default": '#16141d',
        hover: '#16141d',
        active: '#16141d'
      },
      base: {
        "default": '#ff6445',
        hover: '#fe6aff',
        active: '#00d3ff'
      },
      background: {
        "default": '#16141d',
        hover: '#fe6aff',
        active: '#00d3ff'
      }
    },
    caution: {
      foreground: {
        "default": '#16141d',
        hover: '#16141d',
        active: '#16141d'
      },
      base: {
        "default": '#ffe137',
        hover: '#fe6aff',
        active: '#00d3ff'
      },
      background: {
        "default": '#16141d',
        hover: '#fe6aff',
        active: '#00d3ff'
      }
    },
    help: {
      foreground: {
        "default": '#16141d',
        hover: '#16141d',
        active: '#16141d'
      },
      base: {
        "default": '#2ac5e0',
        hover: '#fe6aff',
        active: '#00d3ff'
      },
      background: {
        "default": '#16141d',
        hover: '#fe6aff',
        active: '#00d3ff'
      }
    }
  }
};
export var elevation = {
  level20: {
    offsetX: 0,
    offsetY: 5,
    blur: 20,
    spread: 5,
    boxShadow: '0px 5px 20px 5px'
  },
  glasswall: {
    offsetX: 0,
    offsetY: 0,
    blur: 16,
    spread: 0,
    boxShadow: '0px 0px 16px 0px'
  },
  level16: {
    offsetX: 0,
    offsetY: 4,
    blur: 16,
    spread: 4,
    boxShadow: '0px 4px 16px 4px'
  },
  level12: {
    offsetX: 0,
    offsetY: 3,
    blur: 12,
    spread: 3,
    boxShadow: '0px 3px 12px 3px'
  },
  level8: {
    offsetX: 0,
    offsetY: 2,
    blur: 8,
    spread: 2,
    boxShadow: '0px 2px 8px 2px'
  },
  level4: {
    offsetX: 0,
    offsetY: 1,
    blur: 4,
    spread: 1,
    boxShadow: '0px 1px 4px 1px'
  }
};
export var shape = {
  round: {
    borderRadius: 12
  },
  sharp: {
    borderRadius: 0
  },
  pill: {
    borderRadius: 12
  }
};
export var spacing = {
  standard: {
    borderRadius: {
      one: 12,
      two: 8,
      three: 16
    },
    padding: {
      one: 4,
      two: 8,
      three: 12,
      four: 16,
      five: 20,
      six: 24,
      seven: 28,
      eight: 32,
      intermediate: 12
    }
  },
  high: {
    borderRadius: {
      one: 8,
      two: 8,
      three: 12
    },
    padding: {
      one: 0,
      two: 4,
      three: 8,
      four: 12,
      five: 16,
      six: 20,
      seven: 24,
      eight: 28,
      intermediate: '6'
    }
  }
};
var semantics = {
  breakpoint: breakpoint,
  color: color,
  elevation: elevation,
  shape: shape,
  spacing: spacing
};
export default semantics;